import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ReportingHeadView from '../../views/Taskmanagement/ReportingHeadView';
import MyTasks from '../../views/Taskmanagement/Mytasks';
import ManagerDashboard from '../../views/Taskmanagement/PMdashboard';
import TaskApprovalView from '../../views/Taskmanagement/TaskApprovalView';
import ConfigView from '../../views/Taskmanagement/configuration/ConfigView';
import UserTaskAnalytics from '../../views/Taskmanagement/Analytics/UserAnalytics/UserTaskAnalytics';
import HeadAnalytics from '../../views/Taskmanagement/Analytics/UserAnalytics/ReportingHeadAnalytics';
import AllDepartmentTasks from '../../views/Taskmanagement/AllDepartmentTasks';

const TaskManagementRouter = () => {
  return (
    <Routes>
      <Route path="reporting-head" element={<ReportingHeadView />} />
      <Route path="my-tasks" element={<MyTasks />} />
      {/* <Route path="all-department-tasks" element={<AllDepartmentTasks />} /> */}
      <Route path="pm-overview" element={<ManagerDashboard />} />
      <Route path="task-configurations" element={<ConfigView />} />
      <Route path="approval-tasks" element={<TaskApprovalView />} />
      <Route path="user-task-analytics" element={<UserTaskAnalytics />} />
      <Route path="head-analytics" element={<HeadAnalytics />} />
    </Routes>
  );
};

export default TaskManagementRouter;
